// extracted by mini-css-extract-plugin
export default {"cards":"card_cards__JF8LE","cradimg":"card_cradimg__UFgeB"};